/** MCP HTTP endpoint for the Pulse app the browser is on. */
export function mcpServerUrl(origin: string): string {
  if (typeof origin !== 'string' || origin.trim().length === 0) {
    throw new Error('MCP URL requires an origin.');
  }
  let parsed: URL;
  try {
    parsed = new URL(origin);
  } catch {
    throw new Error('MCP URL requires a valid origin.');
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    throw new Error('MCP URL requires an http(s) origin.');
  }
  return `${parsed.origin}/api/mcp`;
}

export function mcpConfigSnippet(token: string, origin: string): string {
  if (typeof token !== 'string' || token.length === 0) {
    throw new Error('MCP config requires a token.');
  }
  return JSON.stringify(
    {
      mcpServers: {
        pulse: {
          url: mcpServerUrl(origin),
          headers: { Authorization: `Bearer ${token}` },
        },
      },
    },
    null,
    2,
  );
}

export function devkitInstallUrl(origin: string): string {
  return mcpServerUrl(origin).replace(/\/api\/mcp$/, '/api/devkit/install.sh');
}

/** Hosted installer. The server rejects the download without a PAT. */
export function devkitInstallCommand(token: string, origin: string): string {
  if (typeof token !== 'string' || token.length === 0) {
    throw new Error('Devkit install requires a token.');
  }
  if (!token.startsWith('bb_pat_')) {
    throw new Error('Devkit install requires a personal access token (bb_pat_…).');
  }
  const pulseUrl = new URL(mcpServerUrl(origin)).origin;
  return [
    `PULSE_URL='${pulseUrl}'`,
    `PULSE_PAT='${token}'`,
    'bash <(curl -fsSL -H "Authorization: Bearer $PULSE_PAT" "$PULSE_URL/api/devkit/install.sh")',
  ].join(' ');
}
